<p-button
  icon="pi pi-lock"
  [outlined]="true"
  [label]="label"
  severity="secondary"
  (onClick)="packLimitationService.openModal(limitedFeature)"
  [pTooltip]="'lockedButton.tooltip' | transloco"
  [fluid]="fluid"
/>
